import { useSelector } from 'react-redux'
import { Roles } from '../models';
import { AppStore } from '../redux/store';
import { CompanyClient } from '../types/smartwatch';

// CC id de "Ellie-care General" por entorno (cambia entre dev/uat/prod)
const ELLIE_CARE_GENERAL_CC_ID = process.env.REACT_APP_ELLIE_CARE_GENERAL_CC_ID;

const getAuthStatus = (role: Roles, CC: CompanyClient | undefined, companyClientId?: string ) => {

    const isSuperAdmin = role === Roles.SUPERADMIN;
    const isAdmin = role === Roles.ADMIN;
    const isOperator = role === Roles.OPERATOR;
    const isUser = role === Roles.USER;
    const isCompanyClient = CC !== null;
    // El JWT del BO no trae el company_client_id de forma confiable; se resuelve vía
    // /users_roles por email al loguearse (ver loadOperatorCompanyClient en user.service).
    // Un SuperAdmin global puede no tener company_client_id; en ese caso también es Ellie-care General.
    const isEllieCareGeneral =
        (!!ELLIE_CARE_GENERAL_CC_ID && companyClientId === ELLIE_CARE_GENERAL_CC_ID) ||
        (isSuperAdmin && !companyClientId);
    // Solo admins/superadmins de Ellie-care General gestionan el plan_type
    const canManagePlanType = (isSuperAdmin || isAdmin) && isEllieCareGeneral;
    // Solo SuperAdmins de Ellie-care General pueden transferir un reloj de Company Client
    const canTransferCompany = isSuperAdmin && isEllieCareGeneral;
    return { isAdmin, isOperator, isSuperAdmin, isCompanyClient, isUser, canManagePlanType, canTransferCompany, isEllieCareGeneral };
}



const useAuth = () => {

    const userState = useSelector((store: AppStore) => store.user);
    const { role, profiles, company_client, company_client_id, id } = userState;
    const { isAdmin, isOperator, isSuperAdmin, isCompanyClient, isUser, canManagePlanType, canTransferCompany, isEllieCareGeneral } = getAuthStatus(role, company_client, company_client_id);

    return { role, profiles, status, isAdmin, company_client, company_client_id, isOperator, isSuperAdmin, isCompanyClient, isUser, canManagePlanType, canTransferCompany, isEllieCareGeneral, id};
}

export default useAuth;
